import React, { useState, useEffect } from "react";
import { BreadCrumb } from "primereact/breadcrumb";
import { useActif } from "../../../Context/ActifContext";
import { Tag } from "primereact/tag";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import "./detailActif.css";
import NousContacter from "../../NousContacterActif/nousContacter";
import ListeServices from "../ListeServices/ListeServices";
import { Card } from "primereact/card";

export const DetailActif = () => {
  const [openDialog, setDialog] = useState(false);
  const { selectedActif = {}, setSelectedActif } = useActif();

  // ⚙️ Responsive body class (conservé)
  useEffect(() => {
    const handleResize = () => {
      document.body.classList.remove("mobile", "tablet", "desktop");
      if (window.innerWidth <= 767) {
        document.body.classList.add("mobile");
      } else if (window.innerWidth <= 1199) {
        document.body.classList.add("tablet");
      } else {
        document.body.classList.add("desktop");
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 🖱️ Sélection d'un nouvel actif (sans stockage)
  const handleActifClick = (newActif) => {
    setSelectedActif(newActif || {});
  };

  const items = [
    {
      label: "Liste des actifs",
      template: () => (
        <a href="/Liste" onClick={() => handleActifClick({})}>
          Liste des actifs
        </a>
      ),
    },
    {
      label: (
        <>
          {selectedActif?.nom}
          {/* <Tag value={selectedActif.reference_client} severity="danger"></Tag> */}
        </>
      ),
    },
  ];

  const home = { icon: "pi pi-home", url: "/carte" };

  const openDialogueContact = () => setDialog(true);
  const onHide = () => setDialog(false);

  return (
    <div className="full-width-container">
      <BreadCrumb model={items} home={home} />
      <div className="side-by-side">
        <div className="detailActif">
          <Card>
            <div className="ActifInformation">
              <div className="CarteGeo">
                {selectedActif?.lat && selectedActif?.lon && (
                  <a
                    href={`https://www.google.com/maps/dir/?api=1&destination=${selectedActif.lat},${selectedActif.lon}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      className="cartePhoto"
                      src={`https://maps.googleapis.com/maps/api/staticmap?center=${selectedActif.lat},${selectedActif.lon}&size=640x200&zoom=13&maptype=roadmap&markers=color:red|label:.|${selectedActif.lat},${selectedActif.lon}&key=AIzaSyDZ_LWyM4XMceehwsRkVMahiVxHjOLN4Kg&style=feature:administrative|element:all|visibility:simplified|gamma:1.00|saturation:100&style=feature:administrative.country|element:labels.text|color:0xa12d2d&style=feature:administrative.province|element:labels|visibility:off&style=feature:administrative.locality|element:labels|color:0xa62121&style=feature:administrative.neighborhood|element:labels|color:0xe57878&style=feature:landscape|element:geometry|visibility:simplified|lightness:65|saturation:-100|hue:0xff0000&style=feature:landscape.natural|element:geometry|color:0xf6fff6&style=feature:poi|element:geometry|visibility:simplified|saturation:-100|lightness:80&style=feature:poi|element:labels|visibility:off&style=feature:poi.attraction|element:labels|visibility:off&style=feature:poi.park|element:geometry|visibility:on|saturation:100|lightness:-13|color:0xd6f2d5&style=feature:road.highway|element:geometry|visibility:simplified|color:0xdddddd&style=feature:road.highway|element:labels|visibility:off&style=feature:road.highway.controlled_access|element:labels|visibility:off&style=feature:road.arterial|element:geometry|visibility:simplified|color:0xdddddd&style=feature:road.arterial|element:labels|visibility:off&style=feature:road.local|element:geometry|visibility:simplified|color:0xeeeeee&style=feature:road.local|element:labels.text.fill|color:0xba5858|saturation:-100&style=feature:transit.station|element:all|visibility:off&style=feature:transit.station|element:labels.text.fill|color:0xba5858|visibility:simplified&style=feature:transit.station|element:labels.icon|hue:0xff0036&style=feature:water|element:geometry|visibility:simplified|color:0xa9d2d3&style=feature:water|element:labels.text.fill|color:0x5884ba`}
                      alt=""
                      height="120px"
                      minheight="10px"
                    />
                  </a>
                )}

               {/* <img
                  className="img-fluid"
                  src="../../default_actif.png"
                  alt=""
                  height="120px"
                  minheight="10px"
                />*/}
              </div>

              <div>
                <div className="contact-details">
                  {/* <p>{selectedActif?.nom}</p> */}
                  <p>
                    {selectedActif?.adresse_rue1}, {selectedActif?.adresse_ville}, {selectedActif?.adresse_pays}
                  </p>
                  <p>
                    {selectedActif?.reference_client ? `Référence client : ${selectedActif.reference_client}` : ""}
                  </p>
                </div>
              </div>

              <Button label="NOUS CONTACTER" className="btn-tab" onClick={openDialogueContact} />

              <Dialog header="Contactez-nous" visible={openDialog} style={{ width: "50vw" }} onHide={onHide}>
                <NousContacter selectedActif={selectedActif} setDialog={setDialog} />
              </Dialog>
            </div>
          </Card>
        </div>

        <div className="listeServices">
          <ListeServices />
        </div>
      </div>
    </div>
  );
};
